import { useContext, useEffect } from 'react';

import { IWalletCurrency } from '../../../models/wallet-currency-response.interface';

import { useBalanceState } from '../../../hooks/useBalanceState';

import { ElementLoaderContext } from '../../element-loader/ElementLoader';
import ValueAndIcon from '../../generics/ValueAndIcon';
import styles from './CheckoutBalance.module.scss';

interface ICheckoutBalanceProps {
  currency: IWalletCurrency;
}

const CheckoutBalance = ({ currency }: ICheckoutBalanceProps) => {
  const { balance: currencyBalance, loading: currencyBalanceLoading } = useBalanceState(currency.id);
  const { enableUi, disableUi } = useContext(ElementLoaderContext);

  useEffect(() => {
    if (currencyBalanceLoading) {
      disableUi();

      return;
    }

    enableUi();
  }, [currencyBalanceLoading, enableUi, disableUi]);

  return (
    <>
      <span>Your balance</span>
      <div className={styles['payment-item-value']}>
        <ValueAndIcon
          iconAltText={currency.symbol}
          className={styles['balance']}
          valueSize={16}
          iconSize={16}
          valueToFixed={false}
          icon={currency?.icon}
          value={currencyBalance}
        />
      </div>
    </>
  );
};

export default CheckoutBalance;
